import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const EyeOff: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M12.0005 3C6.50055 3 4.7207 7 1.2207 12C4.7207 17 6.50055 21 12.0005 21C17.5005 21 19.2805 17 22.7805 12C19.2805 7 17.5005 3 12.0005 3Z'
        stroke={fill}
        strokeWidth='2'
      />
      <path
        d='M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default EyeOff
